import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'ea-progress',
    templateUrl: './ea-progress.component.html',
    styleUrls: ['./ea-progress.component.scss'],
    standalone: false
})
export class EaProgressComponent implements OnInit {
  @Input() width: number = 100;
  @Input() maxWidth;
  @Input() color = '#3376f6';
  @Input() displayText = true;
  @Input() size = 'normal';
  @Input() rounded = false;

  constructor() {}

  ngOnInit() {}
}
